import { render } from "./Results.vue?vue&type=template&id=851e4f52&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=851e4f52&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851e4f52"]])

export default __exports__